import {
  USER_FIND_ALL,
  USER_SET_INITIAL_STATE,
  USER_VIEW
} from './userTypes'


const initialState = {
  data: [],
  pagination: {
    currentpage: 1,
    itemcount: 0,
    pagesize: 10,
    firstpage: '',
    lastpage: '',
    nextpages: [],
    prevpages: [],
    totalpages: 0
  },

  viewResult: false
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_SET_INITIAL_STATE:
      return initialState;
    case USER_FIND_ALL:
      return {
        data: action.payload.data,
        pagination: action.payload.pagination
      }
    case USER_VIEW:
    return {
      ...state,
      viewResult: action.payload.data
    }
    default: return state
  }
}

export default reducer
